import React from 'react';
import { Search } from 'lucide-react';

const CategoryFilters = ({ filters, onFiltersChange }) => {
  const handleChange = (e) => {
    onFiltersChange({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="relative md:col-span-2">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        <input
          type="text"
          name="search"
          placeholder="Buscar categorias..."
          value={filters.search || ''}
          onChange={handleChange}
          className="form-input pl-10 w-full"
        />
      </div>
      <div>
        <select
          name="sortBy"
          value={filters.sortBy || 'name'}
          onChange={handleChange}
          className="form-select w-full"
        >
          <option value="name">Ordenar por Nome</option>
          <option value="id">Ordenar por ID</option>
        </select>
      </div>
    </div>
  );
};

export default CategoryFilters;
